import * as React from 'react';
import { Box } from '@mui/system';
import axios from 'axios';
import { PlotGraph } from './PlotGraph';

axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';

export const HttpTotal = React.memo(() => {

    const [data, setData] = React.useState("")
    const isMounted = React.useRef(false)

    React.useEffect(() => {
      isMounted.current = true
  
      return () => {
        isMounted.current = false
      }
    }, [])

    React.useEffect(() => {
        let cancel = false;

        const fetch = async () => {
            if(!cancel) {
                const res = await axios.get("https://router.prajwal5.workers.dev/traffic-change")
                if(isMounted) {
                    setData(res["data"]["data"]);
                }
            }
        };
        fetch();

        return () => {
            cancel = true;
        }
    }, []);

    if(!data) {
        return <></>
    } else {
        return (
            <Box style={{ paddingTop: "8em" }}>
                <PlotGraph data={data} title={"Total Traffic Change vs HTTP Traffic Change"} description = {"Comparison between the total traffic change received from the endpoint over the http traffic change inthe past 30 days"}/>
            </Box>
        )
    }
    
});